/* Native disclosures work without JavaScript; enhance mobile and keyboard behavior. */
(function () {
  'use strict';
  var header = document.querySelector('.ip-site-header');
  if (!header) return;
  // The chat loader may append into the first div while the header is parsing.
  // Keep its existing widget outside the fixed header so it cannot cover Cart.
  function moveChat() {
    var widget = header.querySelector('chat-widget');
    if (widget) { document.body.appendChild(widget); chatObserver.disconnect(); }
  }
  var chatObserver = new MutationObserver(moveChat);
  chatObserver.observe(header, { childList: true, subtree: true });
  moveChat();
  var menu = header.querySelector('.ip-menu');
  var groups = Array.from(header.querySelectorAll('.ip-nav-group'));
  var mobile = window.matchMedia('(max-width: 1050px)');
  function closeGroups() { groups.forEach(function (group) { group.open = false; }); }
  function sync() { menu.open = !mobile.matches; closeGroups(); }
  sync();
  if (mobile.addEventListener) mobile.addEventListener('change', sync);
  else mobile.addListener(sync);
  groups.forEach(function (group) {
    group.addEventListener('toggle', function () {
      if (group.open) groups.forEach(function (other) { if (other !== group) other.open = false; });
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !header.contains(document.activeElement)) return;
    var group = document.activeElement.closest('.ip-nav-group');
    if (group && group.open) {
      group.open = false;
      group.querySelector('summary').focus();
    } else if (mobile.matches && menu.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', function (event) {
    if (!header.contains(event.target)) {
      closeGroups();
      if (mobile.matches) menu.open = false;
    } else if (event.target.closest('a')) {
      closeGroups();
      if (mobile.matches) menu.open = false;
    }
  });
  // Safari does not focus mouse-clicked links. Closing on focusout hides the
  // link between pointer-down and click, cancelling its native navigation.
  document.addEventListener('focusin', function (event) {
    if (!header.contains(event.target)) {
      closeGroups();
      if (mobile.matches) menu.open = false;
    }
  });
})();
